import React, {useState, useEffect} from 'react'
import FirstCard from '../components/work/FirstCard';
import SecondCard from '../components/work/SecondCard';
import ProjectTitle from '../components/work/ProjectTitle';
import RowTwo from '../components/work/RowTwo';
import RowOne from '../components/work/RowOne';
import RwoZero from '../components/work/RwoZero';
import RwoZeroSec from '../components/work/RwoZeroSec';
import RowOneSec from '../components/work/RowOneSec';
import RowTwoSec from '../components/work/RowTwoSec';

import TastyNew from '../components/work/TastyNew';

import AOS from 'aos';
import 'aos/dist/aos.css';


function Work(){
  useEffect(() => {
    AOS.init({once: true}
              
      );
  }, []);

  const [dropdekha, setdropdekha] = useState(false);
  function drop(){
      setdropdekha(!dropdekha);
  }
  const dropUpDown= dropdekha ?  'drop-up':'drop-down';
  return (
    <>
    <div id='work-id' className='work-box'>
        <div className='work-main'>
        <ProjectTitle/>
        <SecondCard/>
           <FirstCard/>
           <RwoZero/>
           <RowOne/>
           <RowTwo/>
           
        </div>
    <div data-aos="fade-up"
            data-aos-duration="1000" className='updown-wrapper'>
      <div  className={dropUpDown}> 
      <span onClick={drop}>
      <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="currentColor" class="bi bi-arrow-down-short" viewBox="0 0 16 16" id="IconChangeColor"> <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z" id="mainIconPathAttribute"></path> </svg>
      </span>
      </div>  
    </div>
      {dropdekha && <div className='work-main-sec-div'>
           <RowOneSec/>
           <RwoZeroSec/>
           <RowTwoSec/>
           <TastyNew/>
      </div>}
    </div>
    </>
  );
}
export default Work;